module.exports = __webpack_public_path__ + "static/death_tyrant-173fa86416d151487ca5ebe9a368400a.jpeg";